module.exports = __webpack_public_path__ + "img/ru2.e50f7a35.jpg";